var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDesktopMobile = function SvgDesktopMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_495_29300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.505L11 7.5C10.725 7.5 10.5 7.725 10.5 8V12.5C10.5 12.775 10.725 13 11 13H13.5C13.775 13 14 12.775 14 12.5V8C14 7.725 13.775 7.505 13.5 7.505ZM13.5 12H11V8.5H13.5V12ZM12 3H3C2.445 3 2 3.445 2 4V10C2 10.55 2.445 11 3 11H6.5V12H5.5V13H9.5V12H8.5V11H9.5V10H3V4H12V6.5H13V4C13 3.445 12.55 3 12 3ZM7.985 6.5L7.5 5L7.015 6.5H5.5L6.735 7.38L6.265 8.835L7.5 7.935L8.735 8.835L8.265 7.38L9.5 6.5H7.985Z",
    fill: "#115180"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_495_29300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(2 2)"
  })))));
};
export default SvgDesktopMobile;